(function () {
  'use strict';

  const button = document.querySelector('[data-back-to-top]');
  if (!button) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let ticking = false;

  function updateVisibility() {
    ticking = false;
    const threshold = Math.max(640, window.innerHeight * 0.85);
    const visible = window.scrollY > threshold;
    button.classList.toggle('is-visible', visible);
    button.setAttribute('aria-hidden', visible ? 'false' : 'true');
    button.tabIndex = visible ? 0 : -1;
  }

  function scheduleVisibilityUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateVisibility);
  }

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: reduceMotion.matches ? 'auto' : 'smooth',
    });

    window.setTimeout(() => {
      document.querySelector('#MainContent')?.focus({ preventScroll: true });
    }, reduceMotion.matches ? 0 : 480);
  });

  window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });
  window.addEventListener('resize', scheduleVisibilityUpdate, { passive: true });
  updateVisibility();
})();
